import { RESOURCE_TYPES } from "@eldrun/content";
import type { Cylinder } from "./movement.ts";

/**
 * Cilindro de colisão de um recurso (tronco, rocha, veio), igual no cliente e no servidor.
 * Recursos atravessáveis (moitas, galhadas, cardumes) não têm colisor.
 */
export function resourceCylinder(typeIndex: number, x: number, y: number, z: number, scale: number): Cylinder | undefined {
  const collider = RESOURCE_TYPES[typeIndex]?.collider;
  if (!collider) return undefined;
  return { x, z, radius: collider[0] * scale, bottom: y - 1, top: y + collider[1] * scale };
}
